var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("StyledDateInput", {
        class: _vm.$style.dateInput,
        on: {
          input: function($event) {
            _vm.error = null
          }
        },
        model: {
          value: _vm.birthday,
          callback: function($$v) {
            _vm.birthday = $$v
          },
          expression: "birthday"
        }
      }),
      _vm._v(" "),
      _c(
        "UpdateFormButton",
        {
          class: _vm.$style.button,
          attrs: { error: _vm.error, "is-loading": _vm.isLoading }
        },
        [
          _c("template", { slot: "error" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.error && _vm.error.message) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "loading" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("button.loading")) + "\n    ")
          ]),
          _vm._v(" "),
          [_vm._v("\n      " + _vm._s(_vm.$t("button.submit")) + "\n    ")]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }